import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {TreatmentJourneyDefinitionDataService} from "./impl/service/ngrx/treatmentJourneyDefinitionData.service";
import {TreatmentJourneyDefinitionRepository} from "./impl/service/ngrx/treatmentJourneyDefinition.repository";


@NgModule()
export class TreatmentJourneyDefinitionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: TreatmentJourneyDefinitionDataService,
                service: TreatmentJourneyDefinitionRepository,
    ) {

        entityDataService.registerServices({
            TreatmentJourneyDefinition: dataService,
        });

        entityServices.registerEntityCollectionServices({
            TreatmentJourneyDefinition: service,
        });
    }
}
